import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Layout from "../components/feature/Layout";
import Home from "../pages/home/page";
import Galerie from "../pages/galerie/page";
import Kontakt from "../pages/kontakt/page";
import Impressum from "../pages/impressum/page";
import MetalhomeKlosek from "../pages/metalhome-klosek/page";
import Agb from "../pages/agb/page";
import Datenschutz from "../pages/datenschutz/page";

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/galerie",
        element: <Galerie />,
      },
      {
        path: "/kontakt",
        element: <Kontakt />,
      },
      {
        path: "/impressum",
        element: <Impressum />,
      },
      {
        path: "/metalhome-klosek",
        element: <MetalhomeKlosek />,
      },
      {
        path: "/agb",
        element: <Agb />,
      },
      {
        path: "/datenschutz",
        element: <Datenschutz />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;